import baseAPI, { parseAPIuseX } from '../app/axios';

export default class Organization {
  static async getOrgEnabledEC(orgId) {
    if (!orgId) throw new Error('getOrgEnabledEC: orgId is empty');

    const response = await baseAPI.get(
      `/ec/retargeting/orgEnabled?orgId=${orgId}`,
    );
    return response?.enabledEC || '';
  }

  static async getECIsEnabledSetting(provider, orgId) {
    if (!provider) throw new Error('getIsEnabledSetting: provider is empty');
    if (!orgId) throw new Error('getIsEnabledSetting: orgId is empty');

    const response = await baseAPI.get(`/ec/${provider}?orgId=${orgId}`);
    if (response?.shopUrl) return true;

    const credential = response?.credential || {};
    // token: 舊版 OAuth；accessToken: OAuth；webhookKey/webhookSecret: client_credentials
    return (
      !!credential?.token ||
      !!credential?.accessToken ||
      (!!credential?.webhookKey && !!credential?.webhookSecret)
    );
  }

  static async getECMembershipTier(provider, orgId) {
    if (!provider) throw new Error('getMembershipTier: provider is empty');
    if (!orgId) throw new Error('getMembershipTier: orgId is empty');

    const response = await baseAPI.get(
      `/ec/${provider}/membershipTier/directly?orgId=${orgId}`,
    );
    return response?.list || [];
  }

  static async getCouponList(orgId) {
    if (!orgId) {
      throw new Error('getCouponList: orgId undefined');
    }

    const response = await parseAPIuseX.get(
      `/coupon/api/v1/couponSet/${orgId}`,
      {
        orgId,
      },
    );

    return response?.data?.couponList || [];
  }
}
